(() => {
  const root = document.documentElement;
  root.dataset.cachorrosRelease = 'infantil-otono-v77';

  const header = document.querySelector('[data-v3-header]');
  if (header) {
    const toggle = header.querySelector('.v3-menu-toggle');
    const nav = header.querySelector('.v3-nav');
    const closeButton = header.querySelector('.v4-drawer__close');
    const scrim = header.nextElementSibling?.classList.contains('v4-menu-scrim') ? header.nextElementSibling : null;
    const mobile = matchMedia('(max-width: 989px)');
    const navGroups = [...header.querySelectorAll('.v3-nav details')];
    const navAnchor = document.createComment('v4-mobile-nav-anchor');
    const scrimAnchor = document.createComment('v4-mobile-scrim-anchor');
    let desktopCloseTimer;
    let scrollFrame;

    nav?.parentNode?.insertBefore(navAnchor, nav);
    scrim?.parentNode?.insertBefore(scrimAnchor, scrim);

    const mountMobileOverlay = () => {
      if (!mobile.matches || !nav) return;
      if (scrim && scrim.parentNode !== document.body) document.body.append(scrim);
      if (nav.parentNode !== document.body) document.body.append(nav);
      nav.dataset.v4Portal = 'true';
      if (scrim) scrim.dataset.v4Portal = 'true';
    };

    const restoreMobileOverlay = () => {
      delete nav?.dataset.v4Portal;
      if (scrim) delete scrim.dataset.v4Portal;
      if (nav && navAnchor.parentNode) navAnchor.parentNode.insertBefore(nav, navAnchor.nextSibling);
      if (scrim && scrimAnchor.parentNode) scrimAnchor.parentNode.insertBefore(scrim, scrimAnchor.nextSibling);
    };

    const syncDrawerViewport = () => {
      if (!mobile.matches || !nav) return;
      const topOffset = Math.max(0, Math.round(header.getBoundingClientRect().top));
      const viewportHeight = Math.round(window.visualViewport?.height || window.innerHeight);
      const drawerHeight = Math.max(320, viewportHeight - topOffset);
      nav.style.setProperty('--v3-drawer-offset', `${topOffset}px`);
      nav.style.setProperty('--v3-drawer-height', `${drawerHeight}px`);
    };

    const updateHeaderScroll = () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        if (header.dataset.menuOpen === 'true') syncDrawerViewport();
      });
    };

    window.addEventListener('scroll', updateHeaderScroll, { passive: true });
    updateHeaderScroll();

    const closeDesktopMenus = () => {
      window.clearTimeout(desktopCloseTimer);
      navGroups.forEach((item) => { item.open = false; });
    };

    const scheduleDesktopClose = (details) => {
      if (mobile.matches) return;
      window.clearTimeout(desktopCloseTimer);
      desktopCloseTimer = window.setTimeout(() => {
        if (!details.matches(':hover') && !details.contains(document.activeElement)) details.open = false;
      }, 140);
    };

    const setOpen = (open, restoreFocus = false) => {
      header.dataset.menuOpen = String(open);
      toggle?.setAttribute('aria-expanded', String(open));
      toggle?.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      if (mobile.matches) {
        if (open) {
          mountMobileOverlay();
          nav.scrollTop = 0;
          syncDrawerViewport();
        }
        nav?.setAttribute('aria-hidden', String(!open));
        nav?.toggleAttribute('inert', !open);
        root.dataset.v4MenuOpen = String(open);
      } else {
        nav?.removeAttribute('aria-hidden');
        nav?.removeAttribute('inert');
        delete root.dataset.v4MenuOpen;
      }
      scrim?.setAttribute('aria-hidden', String(!open));
      if (!open) {
        navGroups.forEach((item) => { item.open = false; });
        restoreMobileOverlay();
      }
      if (restoreFocus) toggle?.focus();
    };

    toggle?.addEventListener('click', () => {
      const next = header.dataset.menuOpen !== 'true';
      setOpen(next);
      if (next) closeButton?.focus({ preventScroll: true });
    });
    closeButton?.addEventListener('click', () => setOpen(false, true));
    scrim?.addEventListener('click', () => setOpen(false, true));
    navGroups.forEach((details) => {
      const summary = [...details.children].find((child) => child.tagName === 'SUMMARY');
      details.addEventListener('toggle', () => {
        if (details.open) navGroups.forEach((other) => { if (other !== details) other.open = false; });
      });
      details.addEventListener('pointerenter', () => {
        if (mobile.matches) return;
        window.clearTimeout(desktopCloseTimer);
        details.open = true;
      });
      details.addEventListener('pointerleave', () => scheduleDesktopClose(details));
      details.addEventListener('focusin', () => {
        if (mobile.matches) return;
        window.clearTimeout(desktopCloseTimer);
        details.open = true;
      });
      details.addEventListener('focusout', (event) => {
        if (!mobile.matches && !details.contains(event.relatedTarget)) scheduleDesktopClose(details);
      });
      summary?.addEventListener('click', (event) => {
        if (mobile.matches || !details.dataset.navUrl) return;
        event.preventDefault();
        window.location.assign(details.dataset.navUrl);
      });
    });
    document.addEventListener('pointermove', () => {
      if (mobile.matches || !navGroups.some((details) => details.open)) return;
      window.clearTimeout(desktopCloseTimer);
      desktopCloseTimer = window.setTimeout(() => {
        navGroups.forEach((details) => {
          if (details.open && !details.matches(':hover') && !details.contains(document.activeElement)) details.open = false;
        });
      }, 140);
    }, { passive: true });
    document.addEventListener('pointerdown', (event) => {
      if (!mobile.matches && !header.contains(event.target)) closeDesktopMenus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (header.dataset.menuOpen === 'true') setOpen(false, true);
        else if (!mobile.matches) closeDesktopMenus();
      }
      if (event.key !== 'Tab' || header.dataset.menuOpen !== 'true' || !mobile.matches) return;
      const focusable = [...nav.querySelectorAll('a,button,summary,input')].filter((element) => !element.disabled && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    mobile.addEventListener('change', () => {
      closeDesktopMenus();
      setOpen(false);
    });
    window.addEventListener('resize', () => {
      if (header.dataset.menuOpen === 'true') syncDrawerViewport();
    }, { passive: true });
    window.visualViewport?.addEventListener('resize', () => {
      if (header.dataset.menuOpen === 'true') syncDrawerViewport();
    }, { passive: true });
    setOpen(false);
  }

  document.querySelectorAll('[data-cc4-video] video').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.controls = false;
    const play = () => video.play().catch(() => {});
    if (video.readyState >= 2) play();
    else video.addEventListener('loadeddata', play, { once: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) play(); });
  });

  document.querySelectorAll('[data-cc4-parts]').forEach((section) => {
    const triggers = [...section.querySelectorAll('[data-part-trigger]')];
    const panels = [...section.querySelectorAll('[data-part-panel]')];
    const copies = [...section.querySelectorAll('[data-part-copy]')];
    const current = section.querySelector('[data-part-current]');
    const activate = (index, focus = false) => {
      triggers.forEach((trigger, itemIndex) => {
        trigger.setAttribute('aria-selected', String(itemIndex === index));
        trigger.tabIndex = itemIndex === index ? 0 : -1;
      });
      panels.forEach((panel, itemIndex) => { panel.hidden = itemIndex !== index; panel.classList.toggle('is-active', itemIndex === index); });
      copies.forEach((copy, itemIndex) => { copy.hidden = itemIndex !== index; copy.classList.toggle('is-active', itemIndex === index); });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (focus) triggers[index]?.focus();
    };
    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => activate(index));
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
        activate((index + direction + triggers.length) % triggers.length, true);
      });
    });
    activate(0);
  });

  const normalizeReviewApp = () => {
    document.querySelectorAll('.sectionRevieWidget3').forEach((widget) => {
      widget.querySelectorAll('.rv3-prev,.rv3-next').forEach((button) => {
        if (button.dataset.cc4Ready === 'true') return;

        button.dataset.cc4Ready = 'true';
        const previous = button.classList.contains('rv3-prev');
        button.setAttribute('aria-label', previous ? 'Reseñas anteriores' : 'Reseñas siguientes');
        button.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="${previous ? 'M11 4 6 9l5 5' : 'm7 4 5 5-5 5'}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      });
      widget.querySelectorAll('.itemsC[data-go]').forEach((card) => {
        if (card.dataset.cc4Ready) return;
        card.dataset.cc4Ready = 'true';
        card.tabIndex = 0;
        card.setAttribute('role', 'link');
        card.addEventListener('keydown', (event) => { if (event.key === 'Enter') card.click(); });
      });
    });
  };
  normalizeReviewApp();
  let reviewAttempts = 0;
  const reviewTimer = window.setInterval(() => {
    normalizeReviewApp();
    reviewAttempts += 1;

    if (reviewAttempts >= 30) window.clearInterval(reviewTimer);
  }, 500);
})();
